import { TicketOptionWithQuantity, ProductInstance } from '@repo/types';

export const hasActiveWaitingList = (ticket: TicketOptionWithQuantity): boolean =>
    ticket.productInstances.some(
        (pi) => pi.hasWaitingList === true && pi.isClosedForBooking === true,
    );

export const productInstanceHasActiveWaitingList = (productInstance: ProductInstance): boolean =>
    productInstance.hasWaitingList === true && productInstance.isClosedForBooking === true;

// ProductMapper produces both Number.MAX_VALUE and Number.MAX_SAFE_INTEGER as
// "no capacity limit" sentinels depending on the product type. Treat them
// uniformly so downstream constraint logic can't drift.
export const isUnboundedCapacity = (capacity: number): boolean =>
    capacity === Number.MAX_VALUE || capacity === Number.MAX_SAFE_INTEGER;

export const getEffectiveCapacity = (ticket: TicketOptionWithQuantity): number => {
    let effectiveCapacity = ticket.capacity;

    if (ticket.productInstances.length === 0) {
        return effectiveCapacity;
    }

    for (const pi of ticket.productInstances) {
        if (isUnboundedCapacity(pi.capacity)) {
            continue;
        }

        if (pi.capacity < effectiveCapacity) {
            effectiveCapacity = pi.capacity;
        }
    }

    return effectiveCapacity;
};
